export default __webpack_public_path__ + "static/media/graficos(B).65a0cf35.svg";